import { render, staticRenderFns } from "./DietPlanSidebar.vue?vue&type=template&id=ac6f41ec&scoped=true&"
import script from "./DietPlanSidebar.vue?vue&type=script&lang=js&"
export * from "./DietPlanSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DietPlanSidebar.vue?vue&type=style&index=0&id=ac6f41ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6f41ec",
  null
  
)

export default component.exports